export default "__VITE_ASSET__DkRFT8JC__"